import { setCallback } from '@/utils/auth/callbacks';
import { getUTCEpochTime } from '@/utils/datetime';
import { Auth } from 'aws-amplify';
import { deleteCookie, getCookie, setCookie } from 'cookies-next';

export const DEFAULT_SESSION_LIMIT_VALUE = 720;
export const NO_SESSION_LIMIT_VALUE = -1;

const sessionTimeoutCookieName = 'sessionLimit';

export function startSessionTimer() {
  setCookie(sessionTimeoutCookieName, getUTCEpochTime(), {
    sameSite: 'strict',
  });
}

export function removeSessionTimer() {
  deleteCookie(sessionTimeoutCookieName);
}

export function checkSessionLimit(
  timeout = DEFAULT_SESSION_LIMIT_VALUE,
  { router, updateSnack }
) {
  const sessionTimeout = getCookie(sessionTimeoutCookieName);
  if (!sessionTimeout || timeout === NO_SESSION_LIMIT_VALUE) {
    return;
  }
  const currTime = getUTCEpochTime();
  const difference = currTime - sessionTimeout;
  if (difference > timeout * 60 * 1000) {
    Auth.signOut().then(() => {
      setCallback(router?.asPath);
      router?.push('/login');
      updateSnack?.({
        severity: 'warning',
        message: 'Session expired. Please log in again.',
      });
    });
  }
}
